import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { ELEVES_CUSTOM_FIELDS_KEY } from './useElevesCustomFields';
import { OldCustomFieldOption } from '@teetsh/app/src/types/oldCustomField';
import { ELEVES_VIEWS_KEY } from '@teetsh/app/src/queries/eleves/views/useElevesViews';

function createEleveCustomFields(props: {
  schoolyearId: string;
  schoolId: string;
  name: string;
  type: string;
  customFieldId: string;
  options: OldCustomFieldOption[];
  viewId?: string;
}) {
  const requestURL = `/schoolyears/${props.schoolyearId}/schools/${props.schoolId}/eleves-custom-fields`;
  return request(requestURL, {
    method: 'POST',
    body: {
      id: props.customFieldId,
      name: props.name,
      type: props.type,
      options: props.options,
      viewId: props.viewId,
    },
  });
}

export default function useCreateElevesCustomFields() {
  const { schoolyear, school } = useSchoolSchoolyear();
  const queryClient = useQueryClient();

  const { mutateAsync } = useMutation({
    mutationFn: (p: {
      name: string;
      customFieldId: string;
      type: string;
      options: OldCustomFieldOption[];
      viewId?: string;
    }) =>
      createEleveCustomFields({
        schoolyearId: schoolyear.id,
        schoolId: school.id,
        name: p.name,
        type: p.type,
        customFieldId: p.customFieldId,
        options: p.options,
        viewId: p.viewId,
      }),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ELEVES_CUSTOM_FIELDS_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [ELEVES_VIEWS_KEY],
      });
    },
  });
  return mutateAsync;
}
